module.exports = __webpack_public_path__ + "static/media/instagramIcon.a4c28aec.svg";